<template>
  <div class="item">
    <div class="card item-card shadow-sm" @click="clicked">
      <div class="body product_item">
        <span class="label onsale txt_price">{{ item.price | exchange_rate }}</span>

        <div class="thumb-box">
          <progressive-img
            :src="item.image"
            :blur="30"
            class="thumb-img"
          />
        </div>

        <div
          class="product_details"
          v-tooltip="item.title"
          :class="{ long_text: (item.code + item.title).length > 20 }"
        >
          {{ fn_getWord(item.code + " " + item.title) }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* your card is fixed 160x160 */
.item-card{
  height: 160px;
  width: 160px;
  overflow: hidden; /* ✅ keep everything inside */
}

/* use flex column to reserve space for image + text */
.product_item{
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* ✅ image area: fixed height so it will never overwrite text */
.thumb-box{
  height: 115px;              /* image area */
  width: 100%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex: 0 0 115px;
}

/* progressive-img wrapper should fill the box */
.thumb-img{
  width: 100% !important;
  height: 100% !important;
  max-width: none !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* internal <img> */
.thumb-box :deep(img){
  width: 100%;
  height: 100%;
  object-fit: contain;       /* ✅ no crop */
  object-position: center;
}

/* ✅ text area */
.product_details{
  flex: 1 1 auto;
  padding: 8px;
  font-size: 12px;
  line-height: 14px;
  overflow: hidden;
}
</style>
<!-- img-fluid cp_img thumb? -->
<script>
import store from "@/store";
import { mapState, mapGetters } from "vuex";
export default {
  name: "Item",
  props: {
    item: Object,
  },
  data() {
    return {
      showAll: false,
      item_title: "",
    };
  },
  computed: {
    selected_currency() {
      return store.getters["currency/selected_currency"];
    },
  },
  methods: {
    clicked: function (event) {
      this.$emit("click", this.item, event);
    },
    fn_getWord(desc) {
      if (this.showAll) return desc;

      let value = desc;
      let length = 40;
      if (value.length <= length) {
        return value;
      } else {
        return value.substring(0, length) + "...";
      }
      this.$emit("click");
    },
  },
};
</script>
<style scoped>
</style>